// extracted by mini-css-extract-plugin
export var videoTextSection = "VideoTextSection-module--videoTextSection--cb727";
export var videoTextSection__ctaLink = "VideoTextSection-module--videoTextSection__ctaLink--a9f43";
export var videoTextSection__desc = "VideoTextSection-module--videoTextSection__desc--29734";
export var videoTextSection__descWrapper = "VideoTextSection-module--videoTextSection__descWrapper--f3025";
export var videoTextSection__title = "VideoTextSection-module--videoTextSection__title--91c63";
export var videoTextSection__video = "VideoTextSection-module--videoTextSection__video--db413";